/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Index_TitleInputs */

const en_admin_resources_index_title = /** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources`)
};

const de_admin_resources_index_title = /** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressourcen`)
};

const es_admin_resources_index_title = /** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos`)
};

const fr_admin_resources_index_title = /** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ressources`)
};

const nl_admin_resources_index_title = /** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voorzieningen`)
};

/** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */
const it_admin_resources_index_title = en_admin_resources_index_title;

/** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */
const pt_br2_admin_resources_index_title = en_admin_resources_index_title;

/** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */
const pl_admin_resources_index_title = en_admin_resources_index_title;

/** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */
const hu_admin_resources_index_title = en_admin_resources_index_title;

/** @type {(inputs: Admin_Resources_Index_TitleInputs) => LocalizedString} */
const ro_admin_resources_index_title = en_admin_resources_index_title;

/**
* | output |
* | --- |
* | "Resources" |
*
* @param {Admin_Resources_Index_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_index_title = /** @type {((inputs?: Admin_Resources_Index_TitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Index_TitleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_index_title(inputs)
	if (locale === "de") return de_admin_resources_index_title(inputs)
	if (locale === "es") return es_admin_resources_index_title(inputs)
	if (locale === "fr") return fr_admin_resources_index_title(inputs)
	if (locale === "nl") return nl_admin_resources_index_title(inputs)
	if (locale === "it") return it_admin_resources_index_title(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_index_title(inputs)
	if (locale === "pl") return pl_admin_resources_index_title(inputs)
	if (locale === "hu") return hu_admin_resources_index_title(inputs)
	return ro_admin_resources_index_title(inputs)
});
export { admin_resources_index_title as "admin.resources.index_title" }